<template>
    <div v-if="links.length > 3">
        <div class="flex items-center justify-end">
            <div class="flex-1 sm:flex sm:items-center sm:justify-end">
                <div>
                    <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" :aria-label="$t('Pagination')">
                        <template v-for="(link, k) in links" :key="k">
                            <div v-if="link.url === null"  class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" v-html="link.label" />
                            <Link v-else class="bg-white border-gray-300 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="{ 'z-10 bg-primary-500 border-primary-700 text-white': link.active, 'text-gray-500 hover:bg-gray-50': !link.active}" :href="link.url" v-html="link.label" />
                        </template>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';

export default {
    components: {
        Link,
    },
    props: {
        links: Array,
    },
}
</script>
